import React, { useEffect, useContext } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import { AuthContext } from "../Context/context";
import { UserDatailContext } from "../Context/userContext";
import { setDefaultHeader } from "../utils/httpClient";
import { LocalStorageKeys, LocalStorageService } from "../utils/LocalStorageService";
import Dashboard from "../Screens/Dashboard";
// import Login from "../Screens/Login";
import Landing from "../Screens/LandingPage";
import SignupScreen from "../Screens/Signup";
import withAuthGuard from "../hoc/withAuthGuard";
import LoginScreen from "../Screens/Login";

function Routing() {
  const [, setUserDetails] = useContext(UserDatailContext);

  const initialLoginState = {
    isLoading: true,
    userName: null,
    userToken: null,
  };

  /* Reducer */
  const loginReducer = (prevState, action) => {
    switch (action.type) {
      case 'RETRIEVE_TOKEN':
        return {
          ...prevState,
          userToken: action.token,
          isLoading: false,
        };
      case 'LOGIN':
        return {
          ...prevState,
          userName: action.userName,
          userToken: action.token,
          isLoading: false,
        };
      case 'LOGOUT':
        return {
          ...prevState,
          userName: null,
          userToken: null,
          isLoading: false,
        };
      case 'REGISTER':
        return {
          ...prevState,
          userName: action.userName,
          userToken: action.token,
          isLoading: false,
        };
      default:
        return prevState;

    }

  };

  const [loginState, dispatch] = React.useReducer(
    loginReducer,
    initialLoginState
  );

  const sessionDurationMs = 24 * 60 * 60 * 1000;

  /*  Auth Context */
  const authContext = React.useMemo(
    () => ({
      signInFun: async (foundUser) => {
        const userToken = String(foundUser?.authToken);
        LocalStorageService.set(LocalStorageKeys.USER_DETAILS, JSON.stringify(foundUser));
        LocalStorageService.set(LocalStorageKeys.USER_TOKEN, userToken);
        LocalStorageService.set(
          LocalStorageKeys.SESSION_EXPIRATION,
          (Date.now() + sessionDurationMs).toString()
        );

        dispatch({ type: "LOGIN", userName: String(foundUser?.userName), token: userToken });
      },

      signOutFun: async () => {
        LocalStorageService.clear();
        dispatch({ type: "LOGOUT" });
      },
    }),
    []
  );

  /*  Session Expiry  */
  useEffect(() => {
    const checkSessionExpiration = () => {
      const expirationTime = LocalStorageService.get(LocalStorageKeys.SESSION_EXPIRATION);
      if(!expirationTime) {
        LocalStorageService.clear();
      }
      if (expirationTime && Date.now() > Number(expirationTime)) {
        LocalStorageService.clear();
        dispatch({ type: "LOGOUT" });
      }
    };

    checkSessionExpiration();
    const interval = setInterval(checkSessionExpiration, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const bootstrapAuth = async () => {
      try {
        const token = LocalStorageService.get(LocalStorageKeys.USER_TOKEN);
        dispatch({ type: "RETRIEVE_TOKEN", token });

        if (token) {
          const userDetails = LocalStorageService.get(LocalStorageKeys.USER_DETAILS);
          await setDefaultHeader("Authorization", `Bearer ${LocalStorageService.get(LocalStorageKeys.USER_TOKEN)}`);

          if (userDetails) {
            setUserDetails(JSON.parse(userDetails));
          }
        }
      } catch (e) {
        dispatch({ type: "RETRIEVE_TOKEN", token: null });
      }
    };

    bootstrapAuth();
  }, []);


  const LoginScreenGuarded = withAuthGuard(LoginScreen, { isPublic: true });
  const SignupScreenGuarded = withAuthGuard(SignupScreen, { isPublic: true });
  const LandingGuarded = withAuthGuard(Landing);
  const DashboardGuarded = withAuthGuard(Dashboard);

  /*  Loader*/
  if (loginState.isLoading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Loader */}
      </div>
    );
  }

  /*  Routes */
  return (
    <AuthContext.Provider value={authContext}>
      <Router basename={process.env.PUBLIC_URL}>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<LoginScreenGuarded />} />
          <Route path="/signup" element={<SignupScreenGuarded />} />

          {/* Private */}
          <Route path="/" element={<LandingGuarded />} />
          <Route path="/Dashboard" element={<DashboardGuarded />} />
          <Route path="/Lung" element={<DashboardGuarded />} />
          <Route path="/demo1k" element={<DashboardGuarded />} />

          {/* Catch All */}
          <Route path="*" element={<LoginScreenGuarded />} />
        </Routes>
      </Router>
    </AuthContext.Provider>
  );
}

export default Routing;
